import SEO from "../components/site/SEO";
import Reveal from "../components/site/Reveal";
import { GARAGE } from "../lib/constants";

const BLOC = ({ titre, children }) => (
  <Reveal>
    <section className="mb-12">
      <h2 className="font-heading font-semibold uppercase text-2xl sm:text-3xl text-brand-navy tracking-tight mb-4 border-l-4 border-brand-red pl-4">
        {titre}
      </h2>
      <div className="text-brand-body leading-relaxed space-y-3 pl-5">{children}</div>
    </section>
  </Reveal>
);

export default function MentionsLegales() {
  return (
    <>
      <SEO
        title="Mentions légales & confidentialité — Promo Pneus, Le Cannet"
        description="Mentions légales et politique de confidentialité du garage Promo Pneus, SARL au Cannet (06). SIRET 894 128 289 00010."
      />
      <section className="bg-brand-dark py-14 sm:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <h1 className="font-heading font-bold uppercase text-4xl sm:text-5xl md:text-6xl text-white tracking-wide leading-none">
              Mentions légales &amp; confidentialité
            </h1>
          </Reveal>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
        <BLOC titre="Éditeur du site">
          <p>SARL Promo Pneus — SIRET 894 128 289 00010</p>
          <p>{GARAGE.adresse}, France</p>
          <p>Téléphone : {GARAGE.telephone} — Email : {GARAGE.email}</p>
          <p>Directeur de la publication : le gérant de la SARL Promo Pneus.</p>
        </BLOC>

        <BLOC titre="Hébergement">
          <p className="bg-brand-light border-l-4 border-brand-red px-4 py-3">
            [À compléter : nom, adresse et téléphone de l'hébergeur du site]
          </p>
        </BLOC>

        <BLOC titre="Données personnelles">
          <p>
            Les informations saisies dans le formulaire de demande de devis (nom, téléphone, email, message)
            sont utilisées uniquement pour traiter votre demande et vous recontacter. Elles ne sont ni vendues,
            ni transmises à des tiers, ni utilisées pour de la prospection.
          </p>
          <p>
            Base légale du traitement : mesures précontractuelles prises à votre demande (article 6.1.b du RGPD).
          </p>
          <p>
            Durée de conservation : 12 mois à compter de votre demande, sauf relation commerciale en cours.
          </p>
        </BLOC>

        <BLOC titre="Vos droits">
          <p>
            Conformément au Règlement général sur la protection des données (RGPD) et à la loi Informatique
            et Libertés, vous disposez de droits d'accès, de rectification, d'effacement, de limitation et
            d'opposition sur les données vous concernant.
          </p>
          <p>
            Pour exercer ces droits, écrivez à <a href={`mailto:${GARAGE.email}`} className="text-brand-red font-semibold hover:text-brand-redhover transition-colors">{GARAGE.email}</a> ou
            par courrier à : Promo Pneus, {GARAGE.adresse}.
          </p>
          <p>
            Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).
          </p>
        </BLOC>

        <BLOC titre="Cookies">
          <p>
            Ce site n'utilise aucun cookie de mesure d'audience ni traceur publicitaire. Aucun consentement
            préalable n'est donc requis.
          </p>
        </BLOC>
      </div>
    </>
  );
}
